module.exports = __webpack_public_path__ + "img/MDV.2ede361f.svg";